import * as Sentry from '@sentry/react';

const init = () => {
  Sentry.init({
    dsn: 'https://efd9ed2c2b83403dacf943cda6c50a28@o263964.ingest.sentry.io/5381391',
  });
};

export default { init };
